<template>
    <div
        class="wikiGuide"
        @click.stop="closeWikiGuide"
    >
        <div class="con">查看百科，了解游戏</div>
        <div class="icon"></div>
    </div>
</template>

<script>
    import {getToday} from '@/utils/utility';
    export default {
        mounted() {
            this.getLocalMsg();
        },
        methods: {
            getLocalStorage() {
                let getLocalStorage = localStorage.getItem('game_wiki_guide');
                if (typeof getLocalStorage === 'string') {
                    let localStorage= JSON.parse(getLocalStorage);
                    return localStorage instanceof Object ? localStorage : {};
                } else {
                    return getLocalStorage instanceof Object ? getLocalStorage : {};
                }
            },
            setLocalStorage() {
                let localData = this.getLocalStorage();
                if (localData.showDay !== getToday()) {
                    localData.count = 1;
                } else {
                    localData.count += 1;
                }
                localData.showDay = getToday();
                localData.totalCount = (localData.totalCount || 0) + 1;
                localStorage.setItem('game_wiki_guide', JSON.stringify(localData));      
            },
            showWikiGuide() {
                let localData = this.getLocalStorage();
                let todayHasShow = localData.showDay === getToday();
                let todayShow = !todayHasShow;
                return ((localData.totalCount || 0) < 10) && (todayShow || localData.count < 3);
            },
            getLocalMsg() {
                let showWikiGuide = this.showWikiGuide();
                if (showWikiGuide) {
                    this.$emit('showWikiGuide', true);
                    this.setLocalStorage();
                    this.$logger.display({
                        value: 'module',
                        ext: {
                            item: [
                                {
                                    id: '',
                                    ext: Object.assign({moduleName: '查看百科，了解游戏'}, this.$root.extData),
                                    pos: ''
                                }
                            ]
                        }
                    });
                } else {
                    this.$emit('showWikiGuide', false);
                }
            },
            closeWikiGuide() {
                this.$emit('closeWikiGuide', false);
            }
        }
    }
</script>

<style lang="scss">
@import "~@/common/style/mixin/utils";
$design-width: 1242;
.wikiGuide {
    width: px2rem(730);
    position: fixed;
    bottom: px2rem(235);
    left: 50%;
    margin-left: px2rem(-365);
    background-image: linear-gradient(180deg, #EFF6FF 0%, #FFFFFF 100%);
    box-shadow: 0 px2rem(10) px2rem(30) 0 rgba(51,136,255,0.10);
    border-radius: px2rem(80);
    display: flex;
    justify-content: space-between;
    .con {
        font-size: px2rem(48);
        color: #3388FF;
        line-height: px2rem(57);
        font-weight: 400;
        padding: px2rem(52) 0 px2rem(52) px2rem(113);
    }
    .icon {
        background: url('~public/assets/imgs/ic_more_wiki.png') no-repeat;
        background-size: px2rem(54) px2rem(54);
        width: px2rem(54);
        height: px2rem(54);
        margin: px2rem(52) px2rem(113) px2rem(52) 0;
        -webkit-animation: arrowmore 1s ease-in-out 1s infinite alternate;
        animation: arrowmore 1s ease-in-out 1s infinite alternate;
    }
}
@keyframes arrowmore {
    0% {
        -webkit-transform: translateX(px2rem(10));
        transform: translateY(px2rem(10));
    }
    100% {
        -webkit-transform: translateY(px2rem(-10));
        transform: translateY(px2rem(-10));
    }
}
</style>